import autosize from 'autosize'

const componentTextAreas = document.querySelectorAll('.js-c-text-area')
autosize(componentTextAreas)
